import { defineComponent as _defineComponent } from 'vue';
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "size-full flex flex-col" };
const _hoisted_2 = { class: "flex-shrink-0 pt-3 pb-1 bg-white" };
const _hoisted_3 = { class: "relative" };
const _hoisted_4 = { class: "absolute right-3 top-1/2 transform -translate-y-1/2 flex items-center gap-1" };
const _hoisted_5 = { class: "flex-1 overflow-y-auto scroll-smooth pb-4" };
const _hoisted_6 = {
    key: 0,
    class: "flex items-center justify-center py-8"
};
const _hoisted_7 = {
    key: 1,
    class: "flex items-center justify-center py-8"
};
const _hoisted_8 = {
    key: 2,
    class: "space-y-2"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = { class: "flex-1" };
const _hoisted_11 = { class: "text-badge font-medium" };
const _hoisted_12 = {
    key: 0,
    class: "w-3 h-3 text-white",
    fill: "none",
    stroke: "currentColor",
    viewBox: "0 0 24 24"
};
import { computed, ref } from 'vue';
import { X, Search } from 'lucide-vue-next';
import { useHomeFilterStore } from './homeFilterStore';
export default /*@__PURE__*/ _defineComponent({
    __name: 'home-filter-dialog-condition',
    setup(__props) {
        const homeFilterStore = useHomeFilterStore();
        const searchTerm = ref('');
        // Filter conditions based on search term
        const filteredConditions = computed(() => {
            return homeFilterStore.conditions.filter(condition => condition.name.toLowerCase().includes(searchTerm.value.toLowerCase()));
        });
        const handleConditionToggle = (conditionId) => {
            homeFilterStore.toggleConditionSelection(conditionId);
        };
        const clearSearch = () => {
            searchTerm.value = '';
        };
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((searchTerm).value = $event)),
                            type: "text",
                            placeholder: "Search conditions...",
                            class: "w-full p-2 pr-20 border border-badge/30 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary2 focus:border-primary2 text-badge"
                        }, null, 512), [
                            [_vModelText, searchTerm.value]
                        ]),
                        _createElementVNode("div", _hoisted_4, [
                            (searchTerm.value)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    onClick: clearSearch,
                                    class: "p-1 hover:bg-badge/10 rounded-full transition-colors",
                                    title: "Clear search"
                                }, [
                                    _createVNode(_unref(X), { class: "size-4 text-badge/70 hover:text-badge" })
                                ]))
                                : _createCommentVNode("", true),
                            _createVNode(_unref(Search), { class: "size-4 text-badge/50" })
                        ])
                    ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                    (_unref(homeFilterStore).conditions.length === 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [...(_cache[1] || (_cache[1] = [
                                _createElementVNode("div", { class: "text-badge text-center" }, [
                                    _createElementVNode("div", { class: "text-lg font-medium mb-2" }, "No conditions available"),
                                    _createElementVNode("div", { class: "text-sm opacity-70" }, "Conditions will appear here when loaded")
                                ], -1)
                            ]))]))
                        : (filteredConditions.value && filteredConditions.value.length === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[2] || (_cache[2] = [
                                    _createElementVNode("div", { class: "text-badge text-center" }, [
                                        _createElementVNode("div", { class: "text-lg font-medium mb-2" }, "No conditions found"),
                                        _createElementVNode("div", { class: "text-sm opacity-70" }, "Try a different search term")
                                    ], -1)
                                ]))]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredConditions.value, (condition) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: condition.id,
                                        class: "border-b border-line flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-neutral/50 transition-colors cursor-pointer",
                                        onClick: ($event) => (handleConditionToggle(condition.id))
                                    }, [
                                        _createElementVNode("div", _hoisted_10, [
                                            _createElementVNode("div", _hoisted_11, _toDisplayString(condition.name), 1)
                                        ]),
                                        _createElementVNode("div", {
                                            class: _normalizeClass(["flex-shrink-0 w-5 h-5 border-2 rounded flex items-center justify-center transition-all", [
                                                    condition.isSelected
                                                        ? 'bg-primary2 border-primary2'
                                                        : 'border-badge bg-white hover:border-primary2'
                                                ]])
                                        }, [
                                            (condition.isSelected)
                                                ? (_openBlock(), _createElementBlock("svg", _hoisted_12, [...(_cache[3] || (_cache[3] = [
                                                        _createElementVNode("path", {
                                                            "stroke-linecap": "round",
                                                            "stroke-linejoin": "round",
                                                            "stroke-width": "3",
                                                            d: "M5 13l4 4L19 7"
                                                        }, null, -1)
                                                    ]))]))
                                                : _createCommentVNode("", true)
                                        ], 2)
                                    ], 8, _hoisted_9));
                                }), 128))
                            ]))
                ])
            ]));
        };
    }
});
